import {
    ImportContactsTwoToneIcon,
    EqualizerTwoToneIcon,
    SchoolTwoToneIcon,
    BusinessTwoToneIcon,
    FlashOnTwoToneIcon,
    PeopleAltTwoToneIcon,
    TrendingUpIcon,
} from "./icons"

const beats = [
    {
        icon: ImportContactsTwoToneIcon,
        title: "Introduction",
        desc: "The Illustration of the fields and the specializations inside the healthcare system.",
    },
    {
        icon: SchoolTwoToneIcon,
        title: "Education",
        desc: "Following up on the scientific developments in the fields of work concerned with the healthcare system.",
    },
    {
        icon: EqualizerTwoToneIcon,
        title: "Qualification",
        desc: "The gradation from theoretical studies to the fields of work.",
    },
    {
        icon: BusinessTwoToneIcon,
        title: "Employment",
        desc: "Finding suitable mechanisms and ways to connect graduates with work places.", },
    {
        icon: FlashOnTwoToneIcon,
        title: "Activation",
        desc: "Working on removing the obstacles found in the healthcare system.",
    },
    {
        icon: PeopleAltTwoToneIcon,
        title: "Communication",
        desc: "Building up a communication network among the members of the healthcare system.",
    },
    {
        icon: TrendingUpIcon,
        title: "Development",
        desc: "Utilizing the hidden capabilities found in both the healthcare and the educational systems.",
    },
]

export default beats
